import { iconPaths } from './paths';

/**
 * Stroke-based icon component.
 * Looks up paths from the iconPaths registry by name.
 * Stroke follows currentColor.
 *
 * @param {string} name - icon name (key in iconPaths registry)
 * @param {number} size - width/height in pixels (default 20)
 * @param {number} strokeWidth - stroke weight (default 1.7)
 * @param {string} className - additional class
 * @param {string} title - optional accessible title
 */
export function CwIcon({
    name,
    size = 20,
    strokeWidth = 1.7,
    className,
    title,
    ...rest
}) {
    const paths = iconPaths[name];
    if (!paths) {
        if (typeof console !== 'undefined' && console.warn) {
            console.warn(`<CwIcon>: unknown icon "${name}"`);
        }
        return null;
    }

    const ariaProps = title
        ? { role: 'img', 'aria-label': title }
        : { 'aria-hidden': true };

    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            stroke="currentColor"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            {...ariaProps}
            {...rest}
        >
            {title ? <title>{title}</title> : null}
            {paths}
        </svg>
    );
}
